import { createIcon } from '@chakra-ui/react';

export const ACHOutlineIcon = createIcon({
  displayName: 'ACHOutlineIcon',
  path: (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="none">
        <path
          d="M7.13086 7.71924H4.63086"
          stroke="#6E6789"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.88086 6.49902V8.99902"
          stroke="#6E6789"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.33047 1.25907L6.31547 1.29407L4.86547 4.65907H3.44047C3.10047 4.65907 2.77547 4.72907 2.48047 4.85407L3.35547 2.76407L3.37547 2.71407L3.41047 2.63407C3.42047 2.60407 3.43047 2.57407 3.44547 2.54907C4.10047 1.03407 4.84047 0.689068 6.33047 1.25907Z"
          stroke="#6E6789"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.02523 4.75909C8.80023 4.68909 8.56023 4.65909 8.32023 4.65909H4.86523L6.31523 1.29409L6.33023 1.25909C6.40523 1.28409 6.47523 1.31909 6.55023 1.34909L7.65523 1.81409C8.27023 2.06909 8.70023 2.33409 8.96023 2.65409C9.01023 2.71409 9.05023 2.76909 9.08523 2.83409C9.13023 2.90409 9.16523 2.97409 9.18523 3.04909C9.20523 3.09409 9.22023 3.13909 9.23023 3.17909C9.36523 3.59909 9.28523 4.11409 9.02523 4.75909Z"
          stroke="#6E6789"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.7609 7.09918V8.07418C10.7609 8.17418 10.7559 8.27418 10.7509 8.37418C10.6559 10.1192 9.68086 10.9992 7.83086 10.9992H3.93086C3.81086 10.9992 3.69086 10.9892 3.57586 10.9742C1.98586 10.8692 1.13586 10.0192 1.03086 8.42918C1.01586 8.31418 1.00586 8.19418 1.00586 8.07418V7.09918C1.00586 6.09418 1.61586 5.22918 2.48586 4.85418C2.78586 4.72918 3.10586 4.65918 3.44586 4.65918H8.32586C8.57086 4.65918 8.81086 4.69418 9.03086 4.75918C10.0259 5.06418 10.7609 5.99418 10.7609 7.09918Z"
          stroke="#6E6789"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.355 2.76404L2.48 4.85404C1.61 5.22904 1 6.09404 1 7.09904V5.63404C1 4.21404 2.01 3.02904 3.355 2.76404Z"
          stroke="#6E6789"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.7593 5.63383V7.09883C10.7593 5.99883 10.0293 5.06383 9.0293 4.76383C9.2893 4.11383 9.3643 3.60383 9.2393 3.17883C9.2293 3.13383 9.2143 3.08883 9.1943 3.04883C10.1243 3.52883 10.7593 4.51383 10.7593 5.63383Z"
          stroke="#6E6789"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  ),
});
